module.exports = __webpack_public_path__ + "img/tubiao-20.a5771b5c.png";